const colors = {
  'white': '#ffffff',
  'orange': '#f5a833',
  'yellow': '#fff133',
  'pink-light': '#f09bc2',
  'pink': '#eb3398',
  'green': '#99cc33',
  'blue': '#0066cc',
  'blue-light': '#7fcff1'
}

export default colors



// WEBPACK FOOTER //
// ./src/components/colors.js